import * as React from 'react';

function SvgBookingFilter(props) {
  return (
    <svg
      className="booking-filter_svg__icon"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width={200}
      height={200}
      {...props}
    >
      <path
        d="M349.013 837.973c0 17.721 14.194 32.029 31.773 32.029h262.4a31.858 31.858 0 0031.8-32V642.02H349.014v195.982zm531.058-683.946H143.93c-24.49 0-39.822 26.709-27.506 48.014L337.721 578.02h348.814l221.298-375.98c12.089-21.332-3.214-48.013-27.705-48.013z"
        fillOpacity={0.65}
      />
    </svg>
  );
}

export default SvgBookingFilter;
